/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DDay} from "../DDay";

export enum Layers {
    // Layers order from the top to the bottom.
    SCREENS = "screens",
    WIN_COUNT_UP = "win_count_up",
    WIN_PRESENTATIONS = "win_presentations",
    LOGO = "logo",
    XBET = "xBet",
    ATOMIC_WILD = "atomic_wild",
    FEATURE_ANIMATIONS = "feature_animations",
    FEATURE_ACTIVE = "feature_active",
    FOREGROUND_ANIMATION = "foreground_animation",
    FOREGROUND = "foreground",
    SCATTER_SYMBOLS = "scatter_symbols",
    LOW_SYMBOLS_WIN = "low_symbols_win",
    RADIO_SIGNAL = "radio_signal",
    LOW_SYMBOLS = "low_symbols",
    REEL_BACKGROUND = "reel_background",
    FEATURE_NON_ACTIVE = "feature_non_active",
    BACKGROUND = "background"
}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    constructor() {
        super();
    }

    // Note: these only check the direct children.
    public onResize(): void {
        this.children.forEach((c: any) => {
            if (c.onResize) {
                c.onResize();
            }
        });
    }

    public onOrientationChanged(): void {
        this.children.forEach((c: any) => {
            if (c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        });
    }

    public addChild<T extends PIXI.DisplayObject>(...children: T[]): T {
        children.forEach((c: any) => {
            if (c.onResize) {
                c.onResize();
            }
            if (c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        })

        return super.addChild(...children);
    }
}

export class DDayLayers {

    constructor() {
        for (const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(), 0);
        }
    }

    public static getLayer(name: string): StageLayer | undefined {
        return NolimitApplication.getLayerByName(name);
    }
}
